export function getHasLoadedExternalPrototype(state) {
    return state.hasLoadedExternalPrototype;
}
